export default __webpack_public_path__ + "static/media/horizontal_logo.cff4274c.png";